var React = require('react');

function ToggleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 7.5L6 4.5L3 7.5","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ToggleIcon.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ToggleIcon;

ToggleIcon.default = ToggleIcon;
